/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {SpecialOrderDetailModel} from '../../../api/ms-specialorders/contracts/special-order-detail.model';
import {WarningsEnum} from '../../warnings/warnings.enum';

@Component({
    selector: 'app-spo-detail',
    templateUrl: './spo-detail.component.html',
    styleUrls: ['./spo-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SpoDetailComponent implements OnInit {

    @Input() spoDetail: SpecialOrderDetailModel;
    public requiredForSendLabel = 'Required for send';
    WarningInlineEnum = WarningsEnum;

    constructor() {
    }

    ngOnInit(): void {
    }

    get haveTransportServiceOrRequiresTransportService(): boolean {
        if (this.spoDetail != null) {
            return this.spoDetail.transportService != null || this.spoDetail.requiresTransportService;
        } else {
            return false;
        }
    }
}
